import { valueConverter } from "aurelia-binding";
import * as moment from "moment";

@valueConverter("claimNotesTooltip")
export class ClaimNotesTooltip {
    public toView(notes: any[]): string {
        if (!notes || notes.length === 0) {
            return "Notes";
        }

        const sortedNotes = [...notes].sort((a, b) => {
            return new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime();
        });

        const formattedNotes = sortedNotes.map((note) => {
            const userName = `${note.userFirstName || ""} ${note.userLastName || ""}`.trim() || "Unknown User";
            const dateTime = note.createdOn ? moment(note.createdOn).format("MMM DD, YYYY hh:mm A") : "";
            const message = note.message || "";

            return `${userName}<br />${message}<br/>${dateTime}`;
        });

        return formattedNotes.join("<hr/>");
    }
}
